<template>
    <hts-modal
        :show="visible"
        :title="$t('labels.settingPositionNumber')"
        type="confirm"
        @confirm="confirm()"
        @close="close()">
        <hts-form-input
            v-model="positionNumber"
            :label="$t('labels.positionNumber')"
            type="number"
            name="positionNumber"
            prop="positionNumber" />

        <p v-if="showWaring">
            Sau khi thay đổi số vị trí, các thông tin liên quan sẽ bị mất và không thể khôi phục <span class="text-error-500">
                *
            </span>
        </p>
    </hts-modal>
</template>

<script setup lang="ts">
const visible = ref(false)
const emits = defineEmits(['confirm'])
const positionNumber = ref<number | null>(null)
const showWaring = ref(false)

const open = (number?: number) => {
  if (typeof number === 'number') {
    positionNumber.value = number
    showWaring.value = true
  }
  visible.value = true
}

const resetFields = () => {
  positionNumber.value = null
}

const close = () => {
  resetFields()
  showWaring.value = false
  visible.value = false
}

const confirm = () => {
  if (!Number.isInteger(positionNumber.value)) {
    process.client && $toast().error($t('labels.positionNumberIsInteger'))
    return
  }

  if (typeof positionNumber.value === 'number' && positionNumber.value < 2) {
    process.client && $toast().error($t('labels.positionNumberMinimum'))
    return
  }

  if (typeof positionNumber.value === 'number' && positionNumber.value > 100) {
    process.client && $toast().error($t('labels.positionNumberMaximum'))
    return
  }
  emits('confirm', positionNumber.value)
  close()
}

defineExpose({
  open
})
</script>
